import { MetaTags } from "react-meta-tags";
import {
    Card,
    CardBody,
    CardHeader,
    CardText,
    CardTitle,
    Col,
    Collapse,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    UncontrolledDropdown,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import Axios from 'axios';

import classnames from "classnames";
import Audit from "./Audit";
import Test from "./Test";
import { Link, useHistory } from "react-router-dom";
import Report from "./Report";
import Certificate from "./Certificate";
import Unauthorized from "../../Utility/Unauthorized";

const Audit_report_certificate = (props) => {
    const history = useHistory();
    const projectID = props.match.params.projectID;
    const [activeTab, setactiveTab] = useState();
    const [isAuthorized, setIsAuthorized] = useState(null);
    const [loading, setLoading] = useState(true);

    const toggle = tab => {
        if (activeTab !== tab) {
            setactiveTab(tab);
        }
    };

    useEffect(() => {
        const URLactiveTab = window.location.pathname.split('/')[1];
        if (URLactiveTab === "project") {
            setactiveTab("1");
        }
        if (URLactiveTab === "report") {
            setactiveTab("2");
        }
        if (URLactiveTab === "certificate") {
            setactiveTab("3");
        }

        checkAuthorization();
    }, [projectID]);

    const checkAuthorization = async () => {
        setLoading(true);
        const token = localStorage.getItem("token");
        const userCheck = localStorage.getItem("AuditorID");
        const orgID = localStorage.getItem("orgID");

        if (!token || !userCheck || !projectID) {
            setIsAuthorized(false);
            setLoading(false);
            return;
        }

        try {
            const res = await Axios.post(
                `${process.env.REACT_APP_DEFAULTPATH}check-project-authorization`,
                {
                    userCheck,
                    orgID,
                    projectID
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            );

            if (res.data && res.data.isAuthorized) {
                setIsAuthorized(true);
            } else {
                setIsAuthorized(false);
            }
        } catch (err) {
            console.error("Authorization check failed:", err);
            setIsAuthorized(false);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center my-5 py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (isAuthorized === false) {
        return <Unauthorized />;
    }

    return (
        <React.Fragment>
            <div className="userProfile credentialBreachProfile">
                <MetaTags>
                    <title>Audit | AuditSense</title>
                </MetaTags>
                <Row>
                    <Breadcrumb
                        title="Dashboard"
                        breadcrumbItem="Vulnerability Dashboard"
                        breadcrumbFeature="Vulnerabilities"
                    />
                </Row>

                <Row>
                    <Col xl={12}>
                        <div>
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeTab === "1",
                                        })}
                                        onClick={() => {
                                            toggle("1");
                                            history.push(`/project/${projectID}`);
                                        }}
                                    >
                                        Audit
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        to={`/report/${projectID}`}
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeTab === "2",
                                        })}
                                        onClick={() => {
                                            toggle("2");
                                            history.push(`/report/${projectID}`);
                                        }}
                                    >
                                        Report
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeTab === "3",
                                        })}
                                        onClick={() => {
                                            toggle("3");
                                            history.push(`/certificate/${projectID}`);
                                        }}
                                    >
                                        Certificate
                                    </NavLink>
                                </NavItem>
                            </Nav>

                            <TabContent activeTab={activeTab} className="p-3 text-muted">
                                {activeTab === "1" && <Audit projectID={projectID} />}
                                {activeTab === "2" && <Report projectID={projectID} />}
                                {activeTab === "3" && <Certificate projectID={projectID} />}
                            </TabContent>
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    );
};

export default Audit_report_certificate;
